export default "__VITE_ASSET__d02939a1__"